import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * Needs Refill merchandisers list (PD-13938) — units at or below the
 * tenant's refill threshold (`refillBelowFillPct` in Distribution settings).
 * PD-16059 — filters on the derived `merchandiserRefillNeeded` quick-filter
 * rather than a fixed Empty/Low stock bucket, so the tab, the stat card,
 * the map and the Replenishment screen all agree on who needs ice.
 */
export const needsRefillMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers-needs-refill',
	name: 'Needs Refill',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		merchandiserRefillNeeded: {
			defaultValue: [{ id: 'true', label: 'Needs Refill' }],
		},
	},
	columns: createMerchandiserColumns(),
	defaultSortId: 'merchandiser-name',
	sortOrder: 1,
};
